import { loginURL, registerURL } from "../utils/constants";
import { useApi } from "./useApi";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { IIncome, IRegistration, ISurvey } from "@interfaces";
import { persistSession } from "./session";
import dayjs from "dayjs";

const useAuth = () => {
  const { apiPublic, apiPrivate } = useApi();

  const navigate = useNavigate();

  const login = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    const {
      data: { result },
    } = await apiPublic.post(loginURL, { email: email, password: password });

    persistSession(result);

    return result;
  };

  const getUserInfo = () => {
    const user = localStorage.getItem("user");
    if (user) {
      return JSON.parse(user);
    }
  };

  const isRoleUser = () => {
    return getUserInfo()?.role?.roleName == "User";
  };
  const isRoleOwner = () => {
    return getUserInfo()?.role?.roleName == "User";
  };

  const isUserActive = () => {
    return getUserInfo()?.hasActiveSubscription;
  };

  const showInactiveModal = () => {
    if (getUserInfo()?.trialDays && getUserInfo()?.trialDays > 0) {
      return false;
    }
    return !isUserActive();
  };
  const register = async (
    body: IRegistration & ISurvey
  ): Promise<{ id: number }> => {
    const {
      data: { result },
    } = await apiPublic.post<{ result: { id: number } }>(registerURL, {
      ...body,
      isAgreeTerms: true,
    });
    return result;
  };

  const registerMutate = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: (error: any) => void;
  }) =>
    useMutation({
      mutationFn: (body: IRegistration & ISurvey) => register(body),
      onSuccess: (data) => onSuccess && onSuccess(),
      onError: (error) => onError && onError(error),
    });

  const loginMutate = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: (error: any) => void;
  }) =>
    useMutation({
      mutationFn: (body: { email: string; password: string }) => login(body),
      onSuccess: (data) => onSuccess && onSuccess(),
      onError: (error) => onError && onError(error),
    });

  const logout = () => {
    let previous = localStorage.getItem("remainingDaysModalLastShown");
    let previous01 = localStorage.getItem("OnboardingJournyStartModal");
    localStorage.clear();
    localStorage.setItem("remainingDaysModalLastShown", previous!);
    localStorage.setItem("OnboardingJournyStartModal", previous01!);
    navigate("/login");
  };

  return {
    loginMutate,
    register,
    logout,
    registerMutate,
    getUserInfo,
    isUserActive,
    showInactiveModal,
    isRoleUser,
    isRoleOwner,
  };
};

export { useAuth };
